import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: 40,
        marginRight: 40,
    },
    heading: {
        fontSize: 38,
        fontWeight: 900,
        padding: theme.spacing(5, 0, 1, 0),
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
        backgroundColor: '#ECECEC',
        height: 30
    },
    formBtn: {
        width: '100px',
    },
    alertRoot: {
        marginTop: 24,
        marginBottom: 24,
    },
    gridStyle: {
        padding: theme.spacing(5, 0, 5, 0)
    },
    table: {
        width: "100%",
        marginTop: 15,
    },
    tableHead: {
        backgroundColor: "#FFF",
        "& > *": {
            fontSize: 18,
            fontWeight: 700,
            color: "#333333",
            //height: 72,
            verticalAlign: "bottom",
            paddingBottom: 10,
        },
    },
    tableBody: {
        backgroundColor: "#FFF",
        cursor: "pointer",
        borderBottom: "1px solid #979797",
        "& > *": {
            fontSize: 18,
            fontWeight: 500,
            color: "#14191C",
        },
    },
    buttonRoot: {
        padding: 0,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2, 0, 0, 50),
        },
    },
    searchTextBox: {
        '& .MuiOutlinedInput-adornedStart': {
            paddingLeft: 0,
            top:4
        },
        height: 44,
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '44px',
        border: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    signoutBtn: {
        width: 90,
        padding: '6px 8px',
        backgroundColor: '#0049a3',
        borderRadius:5,
        color: '#FFF',
        textAlign:'center'
    },
    tableCell: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        paddingLeft: 10,
        paddingRight: 10,
    },
    signOutTableCell: {
        paddingLeft: 10,
        paddingRight: 5,
    },
    dialogContent: {
        width: 360,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        marginBottom: 15,
        overflow: "hidden",
    },
    popupCancel: {
        width: 163,
        height: 44,
        background: "#ECECEC",
        color: "#03090E",
        textTransform: "none",
        fontWeight: 700,
        fontSize: 19,
    },
    popupApply: {
        width: 163,
        height: 44,
        background: "#02489D",
        textTransform: "none",
        fontWeight: 700,
        fontSize: 19,
    },
    tabFilters: {
        width: "100%",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "16px",
        backgroundColor: "#F6F6F6",
        padding: theme.spacing(0, 2),
        margin: 0,
        '& button.btnFilter': {
            minWidth: 0,
            fontSize: 14,
            fontWeight: 700,
            padding: theme.spacing(.8),
            //margin: "0px 2px",
            marginBlock:8,
            color: "#333333",
            opacity: 0.5,
            '&.active': {
                color: "#333333",
                opacity: 1,
            },
        },
    },
    reviewRoot: {
        fontFamily: "Lato",
        width: "100%",
        margin: 0,
        padding: 0,
        '& .blueBtn': {
            fontFamily: "Helvetica",
            minWidth: 0,
            fontSize: "15px",
            //fontWeight: 700,
            color: "#FFFFFF",
            backgroundColor: "#02489D",
            padding: "8px 24px",
            borderRadius: "6px",
        },
        '& .reviewHeader': {
            width: "100%",
            '& .reviewHeaderGrid': {
                fontFamily: "Helvetica",
                justifyContent: "space-between",
                alignItems: "center",
                margin: 0,
                padding: theme.spacing(2.5, 2.5),
                '& .backSec': {
                    '& .backBtn': {
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#02489D",
                        '& img': {
                            height: "20px",
                        },
                    },
                },
                '& .downSec': {
                    //
                },
            },
        },
        '& .reviewdivider': {
            width: "100%",
            borderTop: "1px solid #979797",
        },
        '& .reviewBody': {
            width: "100%",
            '& .reviewBodyGrid': {
                '& .docGrid': {
                    width: "70%",
                    [theme.breakpoints.up('lg')]: {
                        width: "calc(100% - 400px)",
                    },
                    [theme.breakpoints.only('xs')]: {
                        width: "100%",
                    },
                    flex: 1,
                    '& .docSec': {
                        height: "calc(100vh - 145px)",
                        overflowY: "scroll",
                        backgroundColor: "#FFFFFF",
                        '& .docSecDocument': {
                            '& .docSecPage': {
                                margin: "44px 72px",
                            },
                            '& .docSecPageDivider': {
                                border: "1px solid #979797",
                                margin: "0px 30px",
                            },
                        },
                    },
                },
                '& .formGrid': {
                    width: "30%",
                    [theme.breakpoints.up('lg')]: {
                        width: "400px",
                    },
                    [theme.breakpoints.only('xs')]: {
                        width: "100%",
                    },
                },
                '& .reviewSec': {
                    height: "calc(100vh - 145px)",
                    overflowY: "scroll",
                    backgroundColor: "#ECECEC",
                    '& .reviewSecHeader': {
                        backgroundColor: "rgba(216, 216, 216, 0.45)",
                        padding: "10px 18px",
                        '& .title': {
                            fontFamily: "Lato",
                            fontSize: "18px",
                            fontWeight: 700,
                            color: "#14191C",
                        },
                    },
                    '& .reviewSecBody': {
                        minHeight: "100%",
                        backgroundColor: "#ECECEC",
                        '& .statusSec': {
                            fontFamily: "Lato",
                            color: "#14191C",
                            marginTop: "11px",
                            textAlign: "center",
                            '& .line1': {
                                fontSize: "12px",
                                fontWeight: 400,
                                marginBottom: "1px",
                            },
                            '& .line2': {
                                fontSize: "16px",
                                fontWeight: 700,
                                marginBottom: "1px",
                            },
                            '& .line3': {
                                fontSize: "12px",
                                fontWeight: 400,
                                marginBottom: "1px",
                            },
                        },
                        '& .contentSec': {
                            fontFamily: "Lato",
                            padding: "18px",
                            '& .listSec': {
                                gap: "15px",
                                '& .listItem': {
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "6px",
                                    //marginBottom: "15px",
                                    '& .itemHeader': {
                                        alignItems: "flex-start",
                                        justifyContent: "space-between",
                                        padding: "16px 20px",
                                        '& .name': {
                                            fontSize: "18px",
                                            fontWeight: 700,
                                            color: "#14191C",
                                            marginBottom: "1px",
                                        },
                                        '& .date': {
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            color: "#14191C",
                                        },
                                        '& .actions': {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                            gap: "28px",
                                            marginTop: "2px",
                                            '& .action': {
                                                fontSize: "16px",
                                                fontWeight: 400,
                                                color: "#02489D",
                                                cursor: "pointer",
                                            },
                                        },
                                    },
                                    '& .itemMessage': {
                                        padding: "0px 20px",
                                        fontSize: "18px",
                                        fontWeight: 400,
                                        color: "#14191C",
                                        whiteSpace: "pre-line",
                                    },
                                    '& .itemStatus': {
                                        padding: "19px 20px 26px 20px",
                                        fontSize: "14px",
                                        fontWeight: 400,
                                        color: "#14191C",
                                        //textAlign: "center",
                                    },
                                },
                                '& .addItem': {
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "6px",
                                    //marginBottom: "15px",
                                    '& .addHeader': {
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        padding: "6px 8px",
                                        '& .name': {
                                            fontSize: "18px",
                                            fontWeight: 700,
                                            color: "#14191C",
                                            marginLeft: "12px",
                                        },
                                        '& .actions': {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                            gap: "21px",
                                            '& .action': {
                                                '& .cancelBtn': {
                                                    fontSize: "16px",
                                                    fontWeight: 400,
                                                    color: "#02489D",
                                                    cursor: "pointer",
                                                },
                                            },
                                        },
                                    },
                                    '& .addFormSec': {
                                        padding: "0px 8px",
                                        paddingBottom: "9px",
                                        '& .formLabel': {
                                            fontSize: "18px",
                                            fontWeight: 400,
                                            color: "rgba(20,25,28,0.4)",
                                            paddingLeft: "12px",
                                        },
                                        '& .multilinetextField .MuiOutlinedInput-root': {
                                            height: "100%",
                                            width: "100%",
                                            backgroundColor: "#F6F6F6",
                                            fontSize: "18px",
                                            fontWeight: 400,
                                            color: "#14191C",
                                            borderRadius: "4px",
                                        },
                                        '& .selectField': {
                                            backgroundColor: "#F6F6F6",
                                            '& .MuiSelect-root':{
                                                fontSize: "18px",
                                                fontWeight: 700,
                                                color: "#14191C",
                                                borderRadius: "6px",
                                                '& svg.MuiSelect-icon': {
                                                    color: "rgb(20, 25, 28)",
                                                    //border: "2px solid rgb(20,25,28)",
                                                },
                                            },
                                        },
                                    },
                                },
                                '& .addBtnItem': {
                                    //
                                },
                            },
                        },
                    },
                },
            },
        },
    },
}));